import { useContext } from "react";
import OrgCtx from "routes/organization/organizationContext";

export function useOrgCtx() {
  return useContext(OrgCtx);
}
